interface bulkOrderModel {
    bulkId,country,
    region, 
    time:string,

    calculateWithCar,
    calculateWithTruck,
    changeStatus,
    conveniencePercentage,
    isConvenienceApply,
    isHeavyAttachmentApplied,
    isLoadingFeeApplied,
    isInterRegional,
    isPdasWalletApplied,
    promoUpdate,
    totalCashCollected,
    totalDistance,
    userId,
    damageCoverPercentage
    :number,

    deliveryCharges,
    dropOff : Array<[]>, 

    selectedAddress,
    createdAt, 
    pickup,
    promoResponse
    : object
}

export let bulkOrderModel:bulkOrderModel = {
    bulkId: '',

    calculateWithCar: 0,
    calculateWithTruck: 0,
    changeStatus: 0,
    conveniencePercentage: 0,
    createdAt: { _nanoseconds: 0, _seconds: 0 },
    damageCoverPercentage: 0,
    deliveryCharges: [],
    isConvenienceApply: 0,
    isInterRegional: 0,
    isPdasWalletApplied: 0,
    promoResponse: {},
    promoUpdate: 0,
    region: '',
    selectedAddress: [],
    time: '',
    totalCashCollected: 0,
    userId: 0,
    country: '',
    isHeavyAttachmentApplied: 0,
    isLoadingFeeApplied: 0,
    totalDistance: 0,
    dropOff: [],
    pickup: null
}